<template>
    <div class="modal" tabindex="-1" role="dialog" id="delete-modal">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ title ? title : '¿Está seguro de eliminar el registro?'}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    <i class="far fa-window-close"></i> Cancelar
                </button>
                <button type="button" class="btn btn-danger" @click="deleteItem">
                    <i class="fa fa-trash"></i> Si
                </button>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
export default {
    props: {
        title: {
            type: String,
            required: false
        }
    },
    methods: {
        deleteItem() {
            this.close();
            this.$emit('deleteItem', true);
        },
        show() {
            $('#delete-modal').modal('show');
        },
        close() {
            $('#delete-modal').modal('hide')
        }
    }
}
</script>